import {
  portfolioHoldingsPath,
  portfolioImportPath,
  portfolioRootPath,
} from "@utils/portfolioRouting";

function investLocalePathPrefix(locale: string): string {
  return locale === "en" ? "" : `/${locale}`;
}

export function buildInvestPortfolioRootPath(locale: string): string {
  return portfolioRootPath("invest", investLocalePathPrefix(locale));
}

export function buildInvestPortfolioImportPath(locale: string): string {
  return portfolioImportPath("invest", investLocalePathPrefix(locale));
}

export function buildInvestPortfolioHoldingsPath(
  locale: string,
  portfolioId: string,
): string {
  return portfolioHoldingsPath(
    "invest",
    portfolioId,
    investLocalePathPrefix(locale),
  );
}
